<template>
  <div class="content-item flex align-items-center">
    <div class="content-item-label">
      <span class="red">*</span>{{ name || '简介' }}
    </div>
    <el-input
      id="selectRole"
      maxlength="50"
      show-word-limit
      placeholder="请输入简介"
      v-model="input"
    ></el-input>
  </div>
</template>

<script>
import publicTool from '@/utils/public';
export default {
  name: "wikiIntro",
  props:['contentName', 'actionType'],
  data() {
    return {
      name: publicTool.actionTypeCheck(this.actionType) + '简介'
    }
  },
  computed: {
    input: {
      get() {
        return this.contentName
      },
      set(val) {
        this.$emit('update:contentName',val)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
